import { ITabProps } from '@cian/ui-kit/prev';
import { EMortgageOffersTabs } from '../../../types/mortgage';

interface IGetMortgageOffersTabsParams {
  hasBanks: boolean;
  hasMortgageOffers: boolean;
}

export const getSectionTabs = ({ hasBanks }: IGetMortgageOffersTabsParams): ITabProps[] => {
  const tabs: ITabProps[] = [];

  tabs.push({ title: 'Ипотечные предложения', value: EMortgageOffersTabs.Mortgage });

  if (hasBanks) {
    tabs.push({ title: 'Аккредитованные банки', value: EMortgageOffersTabs.Banks });
  }

  return tabs;
};
